import {
  useCallback,
  useState,
} from 'react';

export default relay => {
  const [loading, setLoading] = useState(false);
  const onRelayReadyStateChange = useCallback(
    ({ done, ready }) => {
      if (done && ready) {
        if (window) {
          window.scrollTo(0, 0);
        }
        setLoading(false);
      }
    },
    [setLoading],
  );
  const changeCategory = useCallback(
    (event, index, categorySlug) => {
      setLoading(true);
      relay.setVariables(
        { categorySlug },
        onRelayReadyStateChange,
      );
    },
    [
      onRelayReadyStateChange,
      relay,
      setLoading,
    ],
  );
  const changeType = useCallback(
    (event, index, type) => {
      setLoading(true);
      relay.setVariables(
        { type },
        onRelayReadyStateChange,
      );
    },
    [
      onRelayReadyStateChange,
      relay,
      setLoading,
    ],
  );
  return {
    changeCategory,
    changeType,
    loading,
  };
};
